import React, { useCallback, useContext } from "react";
import { Autocomplete, TextField } from "@mui/material";
import { endpoints } from "../../../endpoints/endpoints";
import { AppContext } from "../../../context/appContext";
import axios from "axios";

export type CoachOption = { label: string; value: string | null };
type SelectCoachInputProps = {
  coach: CoachOption | null;
  setCoach: (coach: CoachOption | null) => void;
  required?: boolean;
  error?: boolean;
  removeAll?: boolean;
  disabled?: boolean;
};

const useCoachList = (removeAll?: boolean) => {
  const { user, checkSession } = useContext(AppContext);
  const [coachList, setCoachList] = React.useState<CoachOption[]>([]);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    let isMounted = true;
    setLoading(true);
    axios
      .post(endpoints.coach.getAll, { sessionId: user.sessionId })
      .then((response) => {
        checkSession(response);
        let data = response.data;
        if (!removeAll) {
          data = [{ label: "Alle", value: null }, ...data];
        }
        if (isMounted) setCoachList(data);
      })
      .catch(() => {
        if (isMounted) setCoachList([]);
      })
      .finally(() => {
        if (isMounted) setLoading(false);
      });
    return () => {
      isMounted = false;
    };
  }, [checkSession, removeAll, user.sessionId]);
  return { coachList, loading };
};

const SelectCoachInput = (props: SelectCoachInputProps) => {
  const { coach, setCoach, required, error, removeAll, disabled } = props;
  const { coachList, loading } = useCoachList(removeAll);
  const handleChange = useCallback(
    (_: any, newValue: CoachOption | null) => {
      setCoach(newValue);
    },
    [setCoach],
  );
  const getOptionLabel = useCallback((option: CoachOption) => option.label, []);
  const isOptionEqualToValue = useCallback(
    (option: CoachOption, value: CoachOption) => option.value === value.value,
    [],
  );
  return (
    <Autocomplete
      disabled={disabled}
      loading={loading}
      loadingText="Lädt Coachliste..."
      disablePortal
      id="search-booking-coach"
      options={coachList}
      getOptionLabel={getOptionLabel}
      value={coach}
      onChange={handleChange}
      isOptionEqualToValue={isOptionEqualToValue}
      renderInput={(params) => (
        <TextField
          required={required}
          color="secondary"
          {...params}
          label="Coach"
          error={error && !coach}
        />
      )}
    />
  );
};

export default SelectCoachInput;
